import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { storage } from '../../config/fbConfig';
import { ref, getDownloadURL } from 'firebase/storage';


const NewsListComponent = ({ news }) => {
    
    return (
        <Container className='mt-4'>
            <Container fluid className="mt-4">
                <Row>
                    {news && news.map(newsItem => (
                        <Col key={newsItem.id} xs={12} sm={6} md={4} lg={3} >
                            <NewsItemCard newsItem={newsItem} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    );
}

export default NewsListComponent;

const NewsItemCard = ({ newsItem }) => {


    const [featuredImageUrl, setFeaturedImageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const logoPathAndFile = 'news/thumb_' + newsItem.featuredImage;



    useEffect(() => {

        // Function to get download URL from Firebase Storage
        const getDownloadUrl = async () => {
            try {
                const imageRef = ref(storage, logoPathAndFile);
                const url = await getDownloadURL(imageRef);
                setFeaturedImageUrl(url);
                setIsLoading(false);
            } catch (error) {
                console.error('Error getting download URL:', error);
                setIsLoading(false);
            }
        };

        // Call the function to get download URL when component mounts
        getDownloadUrl();
    }, [newsItem.featuredImage]); // Run this effect when logoPath changes

    return (
        <div>
            <div style={{ position: 'relative', width: '256px', height: '144px' }}>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    {isLoading && (
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    )}
                </div>
                <Image src={featuredImageUrl} thumbnail style={{ width: '256px', height: '144px', objectFit: 'cover' }} />
            </div>
            <small className="text-muted" style={{ textAlign: 'right' }}>{newsItem.created?.toDate?.()?.toLocaleDateString?.() ?? ''}</small>
            <p>
                <Link to={`/news/${newsItem.slug}`}>
                    {newsItem.title}</Link>
            </p>

        </div>

    );
}